import { render, staticRenderFns } from "./AppointmentTemplate.vue?vue&type=template&id=e2bad008"
import script from "./AppointmentTemplate.vue?vue&type=script&lang=ts"
export * from "./AppointmentTemplate.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentTemplate.vue?vue&type=style&index=0&id=e2bad008&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports